﻿import { AlertTriangle, CheckCircle2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { StockRequest } from "@/hooks/inventory/useInventoryData";;

export function PendingRequests({
  requests,
  resolveRequest,
}: {
  requests: StockRequest[];
  resolveRequest: any;
}) {
  if (requests.length === 0) return null;

  return (
    <div className="bg-amber-950/20 border border-amber-900/30 rounded-2xl p-5">
      <h3 className="text-amber-500 font-bold flex items-center gap-2 mb-4">
        <AlertTriangle size={18} /> Pedidos da Equipe
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {requests.map((req) => (
          <div
            key={req.id}
            className="bg-slate-900 border border-slate-700 rounded-xl p-4 flex flex-col gap-3 shadow-lg"
          >
            <div className="flex justify-between items-start">
              <div>
                <p className="font-bold text-slate-200">{req.item_name}</p>
                <p className="text-xs text-slate-400">
                  Por: {req.requested_by}
                </p>
              </div>
              <span className="bg-amber-500/20 text-amber-400 text-xs font-bold px-2 py-1 rounded">
                PENDENTE
              </span>
            </div>
            <div className="text-sm bg-slate-950 rounded p-2 text-slate-300">
              <p>
                Estoque atual:{" "}
                <span className="font-mono font-bold">
                  {req.current_qty} {req.unit}
                </span>
              </p>
              <p>
                Solicitado:{" "}
                <span className="font-mono font-bold text-amber-400">
                  +{req.requested_qty} {req.unit}
                </span>
              </p>
            </div>
            <div className="flex gap-2 mt-auto pt-2">
              <Button
                variant="outline"
                className="flex-1 border-red-900/50 text-red-400 hover:bg-red-900/30 hover:text-red-300"
                onClick={() =>
                  resolveRequest.mutate({
                    requestId: req.id,
                    itemId: req.item_id,
                    status: "REJEITADO",
                  })
                }
                disabled={resolveRequest.isPending}
              >
                <XCircle size={16} className="mr-1" /> Rejeitar
              </Button>
              <Button
                className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white"
                onClick={() =>
                  resolveRequest.mutate({
                    requestId: req.id,
                    itemId: req.item_id,
                    status: "APROVADO",
                    approvedQty: req.requested_qty,
                    currentQty: req.current_qty,
                  })
                }
                disabled={resolveRequest.isPending}
              >
                <CheckCircle2 size={16} className="mr-1" /> Aprovar
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
